export default "__VITE_ASSET__2fa63f1b__"